import { render, staticRenderFns } from "./activityDetailTwo.vue?vue&type=template&id=72bf94d7&scoped=true&"
import script from "./activityDetailTwo.vue?vue&type=script&lang=js&"
export * from "./activityDetailTwo.vue?vue&type=script&lang=js&"
import style0 from "./activityDetailTwo.vue?vue&type=style&index=0&id=72bf94d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf94d7",
  null
  
)

export default component.exports